import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { checkGlobalAdminStatus } from '../utils/api.js'

export default function SettingsPage() {
  const navigate = useNavigate()
  const [isGlobalAdmin, setIsGlobalAdmin] = useState(false)

  useEffect(() => {
    checkGlobalAdminStatus()
      .then(res => setIsGlobalAdmin(res.data?.isAdmin === true))
      .catch(() => setIsGlobalAdmin(false))
  }, [])

  const menuItems = [
    {
      icon: '📊',
      title: 'Poll Templates',
      description: 'Create reusable poll templates for your venues',
      path: '/settings/poll-templates'
    },
    {
      icon: '✉️',
      title: 'Message Templates',
      description: 'Customize how update notifications look',
      path: '/settings/message-templates'
    },
    {
      icon: '🌐',
      title: 'Poll Title Format',
      description: 'Choose language and date format for auto poll titles',
      path: '/settings/user-preferences'
    }
  ]

  const adminMenuItems = [
    {
      icon: '📅',
      title: 'Manual Events',
      description: 'Create and manage events directly without a parser',
      path: '/settings/manual-events'
    }
  ]

  return (
    <div>
      <h2 className="section-title">Settings</h2>

      {menuItems.map(item => (
        <div
          key={item.path}
          className="card"
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 16 }}
          onClick={() => navigate(item.path)}
        >
          <div style={{ fontSize: 32 }}>{item.icon}</div>
          <div style={{ flex: 1 }}>
            <div className="card-title">{item.title}</div>
            <div className="card-subtitle">{item.description}</div>
          </div>
          <div style={{ fontSize: 20, color: 'var(--tg-theme-hint-color)' }}>›</div>
        </div>
      ))}

      {isGlobalAdmin && (
        <>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--tg-theme-hint-color)', marginTop: 24, marginBottom: 8 }}>
            Administration
          </div>
          {adminMenuItems.map(item => (
            <div
              key={item.path}
              className="card"
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 16 }}
              onClick={() => navigate(item.path)}
            >
              <div style={{ fontSize: 32 }}>{item.icon}</div>
              <div style={{ flex: 1 }}>
                <div className="card-title">{item.title}</div>
                <div className="card-subtitle">{item.description}</div>
              </div>
              <div style={{ fontSize: 20, color: 'var(--tg-theme-hint-color)' }}>›</div>
            </div>
          ))}
        </>
      )}

      <div className="card" style={{ marginTop: 24, fontSize: 13, color: 'var(--tg-theme-hint-color)' }}>
        <p>📡 Events are checked every 15 minutes automatically.</p>
        <p style={{ marginTop: 8 }}>🔔 Subscribe to venues on the Events tab to receive notifications.</p>
        <p style={{ marginTop: 8 }}>👥 Group chat admins can also send polls directly from venue detail pages.</p>
      </div>
    </div>
  )
}
